import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { RangePicker } from 'components/RangePicker/RangePicker';
import { TimeRange } from 'components/TimeRange/TimeRange';
import { SECONDS_TIMESTAMP_FORMAT } from 'constants/time-and-date';

// The sliders represent time as 48 thirty-minute blocks. The range 9-46
// represents 0430 - 2300. The following functions map between the range
// slider values, and actual times.
const mapRangePickerValueToTime = val => {
  const valueInMinutes = val * 30;
  const hours = Math.floor(valueInMinutes / 60);
  return `${hours < 10 ? '0' : ''}${hours}:${valueInMinutes % 60 || '00'}`;
};

export const mapRangePickerRangeToTimeString = ([lo, hi]) =>
  `${mapRangePickerValueToTime(lo)}-${mapRangePickerValueToTime(hi)}`;

const mapTimeToRangePickerValue = value => {
  value = parseInt(value.replace(/[^\d]/g, ''), 10);
  const hours = Math.floor(value / 100);
  const minutes = value % 100;
  return hours * 2 + Math.floor(minutes / 30);
};

export const mapTimeStringToRangePickerRange = value => {
  const [lo, hi] = value.split('-');
  return [mapTimeToRangePickerValue(lo), mapTimeToRangePickerValue(hi)];
};

class TimeSlider extends PureComponent {
  handleOnChange = value => {
    this.props.onChange(mapRangePickerRangeToTimeString(value));
  };

  render() {
    const { end, start, value } = this.props;

    return (
      <div className="p+">
        <p className="text--medium mb">
          <TimeRange
            startTimestamp={format(start, SECONDS_TIMESTAMP_FORMAT)}
            endTimestamp={format(end, SECONDS_TIMESTAMP_FORMAT)}
          />
        </p>
        <RangePicker
          min={9}
          max={46}
          onChange={this.handleOnChange}
          onChangeEnd={this.handleOnChange}
          value={mapTimeStringToRangePickerRange(value)}
        />
      </div>
    );
  }
}

TimeSlider.propTypes = {
  end: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  start: PropTypes.instanceOf(Date),
  value: PropTypes.string,
};

export { TimeSlider };
